import { Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import InvoiceRightSide from "./InvoiceRightSide";
import InvoiceAddress from "./InvoiceAddress";
import InvoiceDetail from "./InvoiceDetail";
import { dynamicImage } from "../../../../../Utils";

const InvoiceFiveHeader = () => {
  return (
    <Table style={{ width: "100%" }} borderless>
      <tbody>
        <tr style={{ padding: "28px 0 5px", display: "flex", justifyContent: "space-between", alignItems: "center" }} >
          <td className="p-0">
            <Image className="img-fluid" src={dynamicImage("logo/logo.png")} alt="logo" />
          </td>
          <td className="p-0">
            <InvoiceRightSide />
          </td>
        </tr>
        <tr style={{ display: "flex", justifyContent: "space-between" }} >
            <InvoiceAddress />
            <InvoiceDetail />
        </tr>
      </tbody>
    </Table>
  );
};

export default InvoiceFiveHeader;
